<template>
  <div v-show="selectedMessagesIdCopy.length" class="selected-messages-info">
    <div class="selected-messages-info-wrapper">
      <div class="select-all-messages-wrapper" :style="{ maxWidth: checkAll ? '140px' : '120px' }">
        <div class="custom-checkbox-group btn-select-all">
          <div class="checkbox-wrap">
            <input
              :id="`check_all_messages`"
              v-model="checkAll"
              class="input-checkbox"
              type="checkbox"
            >
            <label :for="`check_all_messages`" class="label-checkbox">
              <span>{{ checkAll ? 'Unselect' : 'Select' }} All ({{ selectedMessagesIdCopy.length }})</span>
            </label>
          </div>
        </div>
      </div>
      <tooltip v-if="timeRemaining > 0" :target-ref="$refs.exportButton">
        <span>Time remaining for another case export request: </span>{{ timeRemaining }} sec.
      </tooltip>
      <button
        v-if="!$route.path.includes('media')"
        ref="exportButton"
        :disabled="timeRemaining > 0"
        class="btn-export"
        :class="{ disabled: timeRemaining > 0 }"
        @click="exportMessages"
      >
        <span>Export</span>
      </button>
      <div v-else class="media-export-panel">
        <div
          class="btn-export"
          @click="pinMarked"
        >
          <img :src="priorityIcon" alt="markIcon">
          <span>Mark priority</span>
        </div>
        <CustomSelect
          v-model="selectedFormat"
          placeholder="Export"
          :options="mediaOptions"
          style="width: 150px;"
          @selected="exportMedia"
        />
      </div>
    </div>
  </div>
</template>
<script>
import CustomSelect from '@/components/inputs/CustomSelect.vue';
import Tooltip from '@/components/common/Tooltip.vue';
import priorityIcon from '@/assets/img/case-messages/priority.png';

export default {
  name: 'SelectedMessagesInfo',
  components: {
    Tooltip,
    CustomSelect,
  },
  emits: ['updatedActiveStatus', 'exportMessages', 'exportMedia', 'pinMarked'],
  props: {
    messages: {
      type: Array,
      default: () => [],
    },
    selectedMessagesId: {
      type: Array,
      default: () => [],
    },
    timerStarted: {
      type: Number,
      default: 0,
    }
  },
  data: () => ({
    priorityIcon,
    timeRemaining: 0,
    messagesCopy: [],
    selectedMessagesIdCopy: [],
    selectedFormat: null,
    isCheckedAllMessages: false,
    mediaOptions: [{name: 'csv', id: 1}, {name: 'ufdr', id: 2}],
    messagesOptions: [{name: 'pdf', id: 1}, {name: 'xml', id: 2}, {name: 'csv', id: 3}, {name: 'rsmf', id: 4}],
  }),
  computed: {
    checkAll: {
      get() {
        return this.messages.every(message => message.isActive === true);
      },
      set(value) {
        this.selectedMessagesIdCopy = [];
        this.isCheckedAllMessages = value;

        this.messagesCopy = this.messages.map(message => {
          message.isActive = value;
          if (value) {
            this.selectedMessagesIdCopy.push(message.id);
          }
          return message;
        });

        const params = {
          messages: this.messagesCopy,
          isCheckedAllMessages: this.isCheckedAllMessages,
          selectedMessagesId: this.selectedMessagesIdCopy
        };

        this.$emit('updatedActiveStatus', params);
      }

    },
  },
  watch: {
    messages(val) {
      this.messagesCopy = val.map(message => {
        const existingMessage = this.messagesCopy.find(m => m.id === message.id);
        if (existingMessage && this.isCheckedAllMessages) {
          return {...message, isActive: true};
        }
        return {...message};
      });
    },
    selectedMessagesId(val) {
      this.selectedMessagesIdCopy = val;
    },
    timerStarted(val) {
      this.timeRemaining = val;
    }
  },
  mounted() {
    this.timeRemaining = this.timerStarted;
  },
  methods: {
    uncheckAll() {
      this.messages.forEach(message => message.isActive = false);
      this.messagesCopy.forEach(message => message.isActive = false);
      this.selectedMessagesIdCopy = [];
      this.isCheckedAllMessages = false;

      const params = {
        messages: this.messages,
        isCheckedAllMessages: false,
        selectedMessagesId: []
      };
      this.$emit('updatedActiveStatus', params);
    },

    exportMessages() {
      this.$emit('exportMessages', this.selectedFormat, this.selectedMessagesIdCopy);
    },
    exportMedia(selectedFormat) {
      this.$emit('selectedFormat', this.selectedFormat || selectedFormat);
      this.$emit('exportMedia', this.selectedMessagesIdCopy);
      this.uncheckAll();
    },
    pinMarked() {
      this.$emit('pinMarked', this.selectedMessagesIdCopy);
      this.uncheckAll();
    }
  },
};
</script>
<style scoped lang="scss">
.selected-messages-info {
  position: sticky;
  bottom: 0;
  right: 0;
  width: 100%;
  padding: 24px 16px;
  background-color: var(--accent-color);
  z-index: 100;
  box-sizing: border-box;

  .selected-messages-info-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 50px 0 0;

    .select-all-messages-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;

      .btn-select-all {
        cursor: pointer;
        background-color: transparent;

        .label-checkbox {
          background-color: var(--white-color);
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all .3s ease;
          border: 1px solid var(--accent-color);
          border-radius: 1px;
          margin: 0;

          &:after {
            background: var(--accent-color);
          }

          span {
            padding: 2px 0 0;
            color: var(--white-color);
          }
        }
      }
    }

    .btn-export {
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      border-radius: 79px;
      outline: none;
      min-width: 140px;
      padding: 8px 26px;
      background-color: #fff;
      cursor: pointer;
      transition: all .5s;

      span {
        color: var(--accent-color);
        font-weight: 500;
        font-size: 12px;
        line-height: 120%;
        vertical-align: middle;
      }
    }

    .media-export-panel {
      display: flex;
      align-items: center;
      gap: 15px;

      .btn-export {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 6px 20px;

        span {
          font-weight: 500;
          font-size: 12px;
          line-height: 120%;
          vertical-align: middle;
          color: var(--secondary-text-color);
        }

        img {
          width: 100%;
          max-width: 24px;
          max-height: 24px;
        }
      }
    }

    .disabled {
      background-color: #a5a5a5;

      span {
        color: var(--black-color);
      }
    }
  }
}
</style>
